// extracted by mini-css-extract-plugin
export default {"card":"partner-area-card_card__eJ1n8","logo":"partner-area-card_logo__i20fW","logoWrapper":"partner-area-card_logoWrapper__9ipBi"};